// extracted by mini-css-extract-plugin
export default {"item":"NavigationItem_item__KCmZy","active":"NavigationItem_active__9XQn1"};